import { render } from "./ConsentBox.vue?vue&type=template&id=4dea39dc&scoped=true"
import script from "./ConsentBox.vue?vue&type=script&lang=js"
export * from "./ConsentBox.vue?vue&type=script&lang=js"

import "./ConsentBox.vue?vue&type=style&index=0&id=4dea39dc&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dea39dc"]])

export default __exports__